/**
 * useCasteEntryScreen.js
 * ----------------------
 * Hook for Caste create/edit form screen using shared useMasterEntry.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as casteApi from '../api/casteApi';

export function useCasteEntryScreen() {
  return useMasterEntry({
    entityName: 'Caste',
    apiClient: casteApi.casteClient,
    fetchDetail: casteApi.getCasteDetail,
    createItem: casteApi.createCaste,
    updateItem: casteApi.updateCaste,
    initialForm: {
      name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Caste Category Name is required.';
      }
      return null;
    },
    listPath: '/masters/caste/list',
  });
}
